// ------ actions
export const ACTION_ORDER_LOADED = 'ACTION_ORDER_LOADED';

export const ACTION_ORDER_SUMMARY_LOADED = 'ACTION_ORDER_SUMMARY_LOADED';



// ------ submission errors
export const SUBMISSION_ERROR_CART_EMPTY = 'cart-empty';

export const SUBMISSION_ERROR_CART_INVALID = 'cart-invalid';

export const SUBMISSION_ERROR_CART_STATUS_WRONG = 'cart-status-wrong';

export const SUBMISSION_ERROR_OTHER = 'other';

export const SUBMISSION_ERRORS = [
    SUBMISSION_ERROR_CART_EMPTY,
    SUBMISSION_ERROR_CART_INVALID,
    SUBMISSION_ERROR_CART_STATUS_WRONG,
    SUBMISSION_ERROR_OTHER
];



// ------ nav
export const NAV_ORDERS_BASE = '/orders';

const NAV_ORDERS_DETAIL_BASE = `${NAV_ORDERS_BASE}/:orderId`;

export const NAV_PAGE_ORDER_PAYMENT = `${NAV_ORDERS_DETAIL_BASE}/payment`;

export const NAV_PAGE_ORDER_PAYMENT_RETURN = `${NAV_PAGE_ORDER_PAYMENT}/:paymentId/return`;

export const NAV_PAGE_ORDER_CONFIRMATION_ERROR = `${NAV_ORDERS_BASE}/confirmation/error`;

export const NAV_PAGE_ORDER_CONFIRMATION_SUCCESS = `${NAV_ORDERS_DETAIL_BASE}/confirmation/success`;
